const AfterSalesNoticeRecord = () => import('@/views/main/afterSalesNoticeRecord/index.vue')
export default {
  path: '/main/afterSalesNoticeRecord',
  name: 'AfterSalesNoticeRecord',
  component: AfterSalesNoticeRecord,
  children: []
}
